<div class="g-layout__container">
    <div>
        <div class="flex justify-content-between align-items-center">
            <p class="font-bold  g-c-primaryDarkerColor">
                {{'employee_reports' | translate}}
            </p>
        </div>
        <div class="br"></div>
    </div>
    <div class="mt-3">

        <div class="mt-5">
            <p-table [class]="dir" [value]="reports" [tableStyle]="{ 'min-width': '50rem', 'min-height': '20rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            {{'report' | translate}}

                        </th>
                        <th>
                        </th>
                        <th>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-report>
                    <tr>
                        <td>
                            <p-button class="w-label" icon="{{report.icon}}" (onClick)="viewReport(report.id)"
                                [label]="report.name" [outlined]="true"></p-button>
                        </td>
                        <td>
                        </td>
                        <td>
                            <p-button [outlined]="true" (onClick)="downloadreport(report.id)">
                                <i class="fa-solid fa-file-pdf text-lg  g-c-primary-dark"></i>
                                <span class="font-bold px-2">
                                    {{'download' | translate}}
                                </span>
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
    <div class="my-5 g-c-primaryDarkColor font-bold">
        {{reportHeader}}
    </div>
    <!-- employee_lis -->
    <div class=" mt-5">
        <p-table [class]="dir" styleClass="p-datatable-striped" [value]="users"
            [tableStyle]="{ 'min-width': '50rem', 'min-height': '20rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        {{'index' | translate }}
                    </th>
                    <th>
                        {{'employee_name' | translate}}
                    </th>
                    <th>
                        {{'user_username' | translate}}
                    </th>
                    @if(selectedType=='all')
                    {
                    <th>
                        {{'department_name' | translate}}
                    </th>
                    <th>
                        {{'section_name' | translate}}
                    </th>
                    }@else{
                    <th>
                        {{'department_name' | translate}}
                    </th>
                    }


                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex">
                <tr>
                    <td>
                        {{i+1}}
                    </td>
                    <td>
                        {{user.name}}
                    </td>
                    <td>
                        {{user.username}}
                    </td>

                    @if(selectedType=='all')
                    {
                    <td>
                        {{user.department_name}}
                    </td>
                    <td>
                        {{user.section_name}}
                    </td>
                    }@else{

                    <td>


                        @switch(selectedType){
                        @case ('department_admin') {
                        {{user.department_name}}
                        }
                        @case ('section_admin') {
                        {{user.section_name}}
                        }

                        }

                    </td>
                    }
                </tr>
            </ng-template>
        </p-table>
    </div>



</div>